namespace advisorop.components.advisor {

    export class CuAdvisorCrmController {

        //current user
        user: domains.identity.IUser;

        // input params
        advisor: domains.IAdvisor = { id: 0 };

        // output params
        onCrmLinked: any;

        crm: domains.IAdvisorCrm = { id: 0 };
        externalSystems: Array<domains.IAdvisorExternalSystem>;
        selExternalSystem: domains.IAdvisorExternalSystem = {};
        externalUsers: any;
        selExternalUser: any;
        loading = false;

        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#tabContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading external system/users...",
            bindingOptions: {
                visible: "vm.loading"
            }
        };

        static $inject = ["generalService", "servicerService", "advisorService",
            "identityService", "$location", "$scope", "$q"];
        constructor(private generalService: services.GeneralService,
            private servicerService: services.ServicerService,
            private advisorService: services.AdvisorService,
            private identityService: services.IdentityService,
            private $location: ng.ILocationService,
            private $scope: ng.IScope,
            private $q: ng.IQService) {
        }

        $onInit() {
            this.identityService.getUserPromise()
                .then(response => this.user = response);
        }

        $onChanges(event): void {
            const me = this;
            for (var key in event) {
                //console.log("$_advisor", this.advisor);
                if (key === "advisor") {
                    if (this.advisor.id != 0) {
                        this.crm = this.advisor.advisorCrms.filter(x => x.externalSystemId === domains.ExternalSystem.SALESFORCE
                            || x.externalSystemId === domains.ExternalSystem.ORION)[0];
                        //console.log("x", this.crm);
                        if (typeof this.crm == "undefined") {
                            this.crm = { id: 0 };
                            this.crm.advisorId = this.advisor.id;
                            this.crm.companyGroupId = this.advisor.companyGroup.id;
                            this.identityService.getUserPromise()
                                .then(response => {
                                    //console.log(`User has been loaded: `, this.user);
                                    me.user = response;
                                    me.loadExternalSystems();
                                });
                        } else {
                            this.identityService.getUserPromise()
                                .then(response => {
                                    //console.log(`User has been loaded: `, this.user);
                                    me.user = response;
                                    me.loadExternalSystems(true);
                                });
                        }
                    }
                }
            }
        }

        externalSystemChanged() {
            this.crm.externalSystemId = this.selExternalSystem.id;
            if (this.crm.externalSystemId === domains.ExternalSystem.SALESFORCE) {
                this.loadExternalUsers();
            } else if (this.crm.externalSystemId === domains.ExternalSystem.ORION) {
                this.loadOrionRepresentatives();
            } else {
                this.externalUsers = [];
            }

        }

        externalUserChanged() {
            this.crm.externalSystemAdvisorId = this.selExternalUser.Id;
            this.onCrmLinked({ crm: this.crm });
        }

        loadExternalSystems(bindCrm = false) {
            this.loading = !this.loading;
            let extSysPromise: ng.IHttpPromise<domains.IAdvisorExternalSystem[]>;
            if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
                //console.log(`Loading external systems for servicer...`);
                extSysPromise = this.generalService.getExternalSystems();
            } else {
                //console.log(`Loading external systems for advisor...`);
                extSysPromise = this.advisorService.getExternalSystems();
            }

            extSysPromise.then((data) => {
                this.externalSystems = data.data;
                // console.log("$_external_systems", this.externalSystems);
                this.loading = !this.loading;
                if (bindCrm) {
                    if (this.crm.externalSystemId === domains.ExternalSystem.ORION) {
                        this.loadOrionRepresentatives(true);
                    } else {
                        this.loadExternalUsers(true);
                    }
                }
            })
            .catch((reason) => {
                console.log("Error during load externalSystems");
                console.log(reason);
                this.loading = !this.loading;
            });
        }

        loadExternalUsers(bindCrm = false) {
            this.loading = !this.loading;

            let loadExtUsersPromise: ng.IHttpPromise<any[]>;

            if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
                //console.log(`Loading salesforce user for advisor company group...`, this.advisor);
                loadExtUsersPromise = this.servicerService.loadSalesforceUsers(this.advisor.companyGroup.id);
            } else {
                //console.log(`Loading salesforce users for advisor...`);
                loadExtUsersPromise = this.advisorService.loadSalesforceUsers();
            }

            loadExtUsersPromise.then(data => {
                this.externalUsers = data.data || [];
                // console.log("$_external_users", this.externalUsers);
                this.loading = !this.loading;
                if (bindCrm) {
                    this.selExternalSystem = this.externalSystems.filter(x => x.id === this.crm.externalSystemId)[0];
                    this.selExternalUser = this.externalUsers.filter(x => x.Id === this.crm.externalSystemAdvisorId)[0];
                }
            }, err => {
                this.loading = !this.loading;
                this.generalService.showError(err);
                // console.log("Error during load external users");
                // console.log(reason);
            });
        }

        loadOrionRepresentatives(bindCrm = false) {
            this.loading = !this.loading;

            let loadOrionPromise: ng.IHttpPromise<any[]>;

            if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
                loadOrionPromise = this.servicerService.loadOrionRepresentatives(this.advisor.companyGroup!.id!);
            } else {
                loadOrionPromise = this.advisorService.loadOrionRepresentatives();
            }

            loadOrionPromise.then(data => {
                // Map Orion fields to match dropdown expectations (Id, Username)
                this.externalUsers = (data.data || []).map(r => ({ Id: r.id, Username: r.fullName }));
                this.loading = !this.loading;
                if (bindCrm) {
                    this.selExternalSystem = this.externalSystems.filter(x => x.id === this.crm.externalSystemId)[0];
                    this.selExternalUser = this.externalUsers.filter(x => x.Id === this.crm.externalSystemAdvisorId)[0];
                }
            }, err => {
                this.loading = !this.loading;
                this.generalService.showError(err);
            });
        }
        
    }



    class CuAdvisorCrm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisor: "<",
                onCrmLinked: "&"
            };
            this.controller = CuAdvisorCrmController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/cu-advisor-crm.html";
        }
    }
    angular.module(Constants.APP).component("cuAdvisorCrm", new CuAdvisorCrm());

}